import { useContext } from 'react';
import {
  AccountSocketContext,
  AccountSocketContextType,
} from '../contexts/AccountSocketContext';

export function useAccountSocket(): AccountSocketContextType {
  const context = useContext(AccountSocketContext);
  if (!context) {
    throw new Error(
      'useAccountSocket must be used within an AccountSocketProvider'
    );
  }
  return context;
}
